(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initGlobalQuantity);

  function initGlobalQuantity() {
    var inflight = {};
    var noticeTimers = {};

    function clamp(value, min, max) {
      if (isNaN(value)) value = min;
      if (value < min) value = min;
      if (max > 0 && value > max) value = max;
      return value;
    }

    function readLineMax(lineEl) {
      if (!lineEl) return 0;
      var raw = lineEl.getAttribute('data-line-max');
      if (raw == null || raw === '') return 0;
      var n = parseInt(raw, 10);
      return isNaN(n) ? 0 : n;
    }

    function showStockNotice(lineEl) {
      if (!lineEl) return;
      var key = lineEl.getAttribute('data-line-key') || lineEl.getAttribute('data-line-index') || 'line';
      var notice = lineEl.querySelector('[data-line-notice]');
      if (!notice) return;
      notice.removeAttribute('hidden');
      notice.classList.add('is-visible');
      clearTimeout(noticeTimers[key]);
      noticeTimers[key] = setTimeout(function () {
        notice.classList.remove('is-visible');
        notice.setAttribute('hidden', '');
      }, 3500);
    }

    function readInputValue(input) {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) {
        var attr = parseInt(input.getAttribute('value') || '', 10);
        v = isNaN(attr) ? NaN : attr;
      }
      return v;
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var lang = (document.documentElement && document.documentElement.lang) || 'es';
      try {
        return new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + '€';
      } catch (e) {
        return (cents / 100).toFixed(2) + '€';
      }
    }

    function lineItemPrice(item) {
      if (!item) return 0;
      if (item.line_price != null) return item.line_price;
      if (item.final_line_price != null) return item.final_line_price;
      return item.original_line_price || 0;
    }

    function syncCartLines(items) {
      items = items || [];
      var groups = document.querySelectorAll('[data-cart-items], [data-cart-drawer-items]');
      for (var g = 0; g < groups.length; g++) {
        var lines = groups[g].querySelectorAll('[data-cart-line]');
        for (var i = 0; i < lines.length && i < items.length; i++) {
          var lineEl = lines[i];
          var item = items[i];
          lineEl.setAttribute('data-line-key', item.key);
          lineEl.setAttribute('data-line-index', String(i + 1));
          lineEl.setAttribute('data-line-quantity', String(item.quantity));

          var priceNode = lineEl.querySelector('[data-line-price]');
          if (priceNode && !lineEl.classList.contains('cart-line--sample')) priceNode.textContent = formatMoney(lineItemPrice(item));

          var qtyInput = lineEl.querySelector('[data-quantity-input]');
          if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = String(item.quantity);
        }
      }
    }

    function applyCartLineQuantity(lineEl, line, quantity, input) {
      if (!window.AlkyraCart) return;
      var key = lineEl.getAttribute('data-line-key') || null;
      var inflightKey = key || ('line-' + line);
      if (inflight[inflightKey]) return;
      inflight[inflightKey] = true;
      if (input) input.classList.add('is-loading');

      var prevQty = parseInt(lineEl.getAttribute('data-line-quantity') || '0', 10);

      var request = (line !== null && line !== undefined && !isNaN(line))
        ? window.AlkyraCart.change(line, quantity)
        : window.AlkyraCart.changeByKey(key, quantity);

      request
        .then(function (updated) {
          if (!updated || updated.error) {
            throw new Error((updated && (updated.message || updated.description)) || 'update failed');
          }

          if (quantity === 0 && lineEl && lineEl.parentNode) {
            lineEl.parentNode.removeChild(lineEl);
          }

          // /cart/change.js can momentarily return totals/keys from before the
          // store's discount recalculation settles, so re-fetch the cart for the
          // authoritative state instead of trusting this response directly.
          return window.AlkyraCart.get();
        })
        .then(function (settled) {
          syncCartLines(settled.items);
          dispatch(settled, 'quantity-selector');
        })
        .catch(function (err) {
          var reason = (err && (err.message || (err.payload && err.payload.message))) || 'unknown error';
          console.error('[AlkyraCart] quantity update failed:', reason);
          if (input && lineEl && lineEl.isConnected) {
            input.value = String(prevQty);
          }
          document.dispatchEvent(new CustomEvent('cart:error', {
            detail: { error: err, line: line, quantity: quantity }
          }));
        })
        .finally(function () {
          inflight[inflightKey] = false;
          if (input && input.classList) input.classList.remove('is-loading');
        });
    }

    function handleStep(btn, direction) {
      var wrapper = btn.parentElement;
      if (!wrapper) return;
      var input = wrapper.querySelector('[data-quantity-input]');
      if (!input) return;

      var current = readInputValue(input);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '0', 10);
      if (isNaN(min)) min = 1;

      var lineEl = btn.closest('[data-cart-line]');
      var dataMax = readLineMax(lineEl);
      if (dataMax > 0) max = dataMax;

      if (direction > 0 && max > 0 && (isNaN(current) ? min : current) >= max) {
        input.value = String(max);
        showStockNotice(lineEl);
        return;
      }

      var next = clamp((isNaN(current) ? min : current) + direction, min, max);
      input.value = String(next);

      if (lineEl) {
        var line = parseInt(lineEl.getAttribute('data-line-index'), 10);
        if (!isNaN(line)) applyCartLineQuantity(lineEl, line, next, input);
      }
    }

    document.addEventListener('click', function (event) {
      var minusBtn = event.target.closest('[data-quantity-minus]');
      if (minusBtn) {
        event.preventDefault();
        handleStep(minusBtn, -1);
        return;
      }
      var plusBtn = event.target.closest('[data-quantity-plus]');
      if (plusBtn) {
        event.preventDefault();
        handleStep(plusBtn, 1);
        return;
      }
      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        var lineEl = removeBtn.closest('[data-cart-line]');
        if (!lineEl) return;
        var line = parseInt(lineEl.getAttribute('data-line-index'), 10);
        if (isNaN(line)) return;
        applyCartLineQuantity(lineEl, line, 0, null);
      }
    });

    function handleManualChange(input) {
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '0', 10);
      if (isNaN(min)) min = 1;

      var lineEl = input.closest('[data-cart-line]');
      var dataMax = readLineMax(lineEl);
      if (dataMax > 0) max = dataMax;

      var raw = parseInt(input.value, 10);
      var overMax = max > 0 && !isNaN(raw) && raw > max;
      var qty = clamp(raw, min, max);
      input.value = String(qty);

      if (!lineEl) return;
      var line = parseInt(lineEl.getAttribute('data-line-index'), 10);
      if (isNaN(line)) return;
      var prev = parseInt(lineEl.getAttribute('data-line-quantity') || '0', 10);
      if (qty === prev && !overMax) return;
      if (overMax) showStockNotice(lineEl);
      applyCartLineQuantity(lineEl, line, qty, input);
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-quantity-input]');
      if (input && input.closest('[data-cart-line]')) handleManualChange(input);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest('[data-quantity-input]');
      if (!input || !input.closest('[data-cart-line]')) return;
      event.preventDefault();
      handleManualChange(input);
    });
  }

  function dispatch(cart, source) {
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart, source: source || 'api' } }));
  }
})();